import React from "react";

import styles from "./Tag.module.scss";

interface ITagProps {
  label: string;
  color?: string;
}

export const Tag: React.FC<ITagProps> = ({ label, color }) => {
  return (
    <div className={styles.tag} style={{ backgroundColor: color }}>
      {label}
    </div>
  );
};
